import { useMemo } from 'react';
import { startsWithHttps } from '../../utils/helpers/asset/startsWithHttps';
const env = process.env.NEXT_PUBLIC_NODE_ENV ?? 'development';
type AvatarType =
  | 'homepage_carousel'
  | 'under_event_thumbnail'
  | 'search_bar'
  | 'user_profile_avatar_header_menu'
  | 'side_menu_following'
  | 'side_menu_event_page'
  | 'notifications_menu_avatar'
  | 'channel_avatar'
  | 'event_page_avatar'
  | 'chat_rules'
  | 'profile_settings_page'
  | 'order_history'
  | 'event_creation'
  | 'homepage_carousel_mobile'
  | 'under_event_thumbnail_homepage'
  | 'search_bar_mobile'
  | 'followers_tab'
  | 'user_profile_menu'
  | 'event_page'
  | 'channel_page'
  | 'event_page_chat_rules'
  | 'under_event_thumbnail_channel_page'
  | 'profile_settings_page_mobile'
  | 'order_history_mobile'
  | 'homepage_carousel_app'
  | 'under_event_thumbnail_homepage_mobile'
  | 'search_bar_app'
  | 'followers_tab_app'
  | 'user_profile_menu_mobile'
  | 'event_page_mobile';

type BannerType =
  | 'banner_profile_settings_page'
  | 'banner_channel_page'
  | 'banner_profile_settings_page_mobile'
  | 'banner_channel_page_mobile';
type StreamEmbedType =
  | 'avatar_streams_tab'
  | 'avatar_side_menu'
  | 'avatar_add_stream'
  | 'avatar_stream_list'
  | 'avatar_streams_tab_mobile'
  | 'avatar_side_menu_mobile'
  | 'avatar_add_stream_mobile'
  | 'avatar_stream_list_mobile';

type ThumbnailType =
  | 'thumbnail_home_page'
  | 'thumbnail_channel_page'
  | 'thumbnail_channel_page_view_all'
  | 'thumbnail_category_page'
  | 'thumbnail_event_page'
  | 'thumbnail_event_manager'
  | 'thumbnail_search_bar'
  | 'thumbnail_home_page_carousel'
  | 'thumbnail_home_page_view_all'
  | 'thumbnail_channel_page_mobile'
  | 'thumbnail_channel_page_view_all_mobile'
  | 'thumbnail_event_page_streams_list'
  | 'thumbnail_category_page_mobile'
  | 'thumbnail_event_manager_mobile'
  | 'thumbnail_search_bar_mobile';
interface SuffixMap {
  [key: string]: { suffix: string; mobile: boolean };
}
const suffixMap: { [key: string]: SuffixMap } = {
  avatar: {
    homepage_carousel: {
      suffix:
        'users/{channelname}/avatar/alpha_web_avatar_homepage_carousel_{channelname}_36x36.webp',
      mobile: false,
    },
    under_event_thumbnail: {
      suffix:
        'users/{channelname}/avatar/alpha_web_avatar_under_event_thumbnail_{channelname}_36x36.webp',
      mobile: false,
    },
    search_bar: {
      suffix:
        'users/{channelname}/avatar/alpha_web_avatar_search_bar_{channelname}_36x36.webp',
      mobile: false,
    },
    user_profile_avatar_header_menu: {
      suffix:
        'users/{channelname}/avatar/alpha_web_avatar_user_profile_avatar_header_menu_{channelname}_40x40.webp',
      mobile: false,
    },
    side_menu_following: {
      suffix:
        'users/{channelname}/avatar/alpha_web_avatar_side_menu_following_{channelname}_26x26.webp',
      mobile: false,
    },
    side_menu_event_page: {
      suffix:
        'users/{channelname}/avatar/alpha_web_avatar_side_menu_event_page_{channelname}_26x26.webp',
      mobile: false,
    },
    notifications_menu_avatar: {
      suffix:
        'users/{channelname}/avatar/alpha_web_avatar_notifications_menu_avatar_{channelname}_40x40.webp',
      mobile: false,
    },
    channel_avatar: {
      suffix:
        'users/{channelname}/avatar/alpha_web_avatar_channel_avatar_{channelname}_64x64.webp',
      mobile: false,
    },
    event_page_avatar: {
      suffix:
        'users/{channelname}/avatar/alpha_web_avatar_event_page_avatar_{channelname}_64x64.webp',
      mobile: false,
    },
    chat_rules: {
      suffix:
        'users/{channelname}/avatar/alpha_web_avatar_chat_rules_{channelname}_40x40.webp',
      mobile: false,
    },
    profile_settings_page: {
      suffix:
        'users/{channelname}/avatar/alpha_web_avatar_profile_settings_page_{channelname}_177x177.webp',
      mobile: false,
    },
    order_history: {
      suffix:
        'users/{channelname}/avatar/alpha_web_avatar_order_history_{channelname}_40x40.webp',
      mobile: false,
    },
    event_creation: {
      suffix:
        'users/{channelname}/avatar/alpha_web_avatar_event_creation_{channelname}_20x20.webp',
      mobile: false,
    },
    homepage_carousel_mobile: {
      suffix:
        'users/{channelname}/avatar/alpha_mobile_avatar_homepage_carousel_{channelname}_40x40.webp',
      mobile: true,
    },
    under_event_thumbnail_homepage: {
      suffix:
        'users/{channelname}/avatar/alpha_mobile_avatar_under_event_thumbnail_homepage_{channelname}_40x40.webp',
      mobile: true,
    },
    search_bar_mobile: {
      suffix:
        'users/{channelname}/avatar/alpha_mobile_avatar_search_bar_{channelname}_60x60.webp',
      mobile: true,
    },
    followers_tab: {
      suffix:
        'users/{channelname}/avatar/alpha_mobile_avatar_followers_tab_{channelname}_91x91.webp',
      mobile: true,
    },
    user_profile_menu: {
      suffix:
        'users/{channelname}/avatar/alpha_mobile_avatar_user_profile_menu_{channelname}_50x50.webp',
      mobile: true,
    },
    event_page: {
      suffix:
        'users/{channelname}/avatar/alpha_mobile_avatar_event_page_{channelname}_65x65.webp',
      mobile: true,
    },
    channel_page: {
      suffix:
        'users/{channelname}/avatar/alpha_mobile_avatar_channel_page_{channelname}_75x75.webp',
      mobile: true,
    },
    event_page_chat_rules: {
      suffix:
        'users/{channelname}/avatar/alpha_mobile_avatar_event_page_chat_rules_{channelname}_32x32.webp',
      mobile: true,
    },
    under_event_thumbnail_channel_page: {
      suffix:
        'users/{channelname}/avatar/alpha_mobile_avatar_under_event_thumbnail_channel_page_{channelname}_40x40.webp',
      mobile: true,
    },
    profile_settings_page_mobile: {
      suffix:
        'users/{channelname}/avatar/alpha_mobile_avatar_profile_settings_page_{channelname}_130x130.webp',
      mobile: true,
    },
    order_history_mobile: {
      suffix:
        'users/{channelname}/avatar/alpha_mobile_avatar_order_history_{channelname}_50x50.webp',
      mobile: true,
    },
    homepage_carousel_app: {
      suffix:
        'users/{channelname}/avatar/alpha_app_avatar_homepage_carousel_{channelname}_40x40.webp',
      mobile: true,
    },
    under_event_thumbnail_homepage_mobile: {
      suffix:
        'users/{channelname}/avatar/alpha_app_avatar_under_event_thumbnail_homepage_{channelname}_40x40.webp',
      mobile: true,
    },
    search_bar_app: {
      suffix:
        'users/{channelname}/avatar/alpha_app_avatar_search_bar_{channelname}_60x60.webp',
      mobile: true,
    },
    followers_tab_app: {
      suffix:
        'users/{channelname}/avatar/alpha_app_avatar_followers_tab_{channelname}_91x91.webp',
      mobile: true,
    },
    user_profile_menu_mobile: {
      suffix:
        'users/{channelname}/avatar/alpha_app_avatar_user_profile_menu_{channelname}_50x50.webp',
      mobile: true,
    },
    event_page_mobile: {
      suffix:
        'users/{channelname}/avatar/alpha_app_avatar_event_page_{channelname}_65x65.webp',
      mobile: true,
    },
  },
  eventThumbnail: {
    // Define suffixes for eventThumbnail if needed
    thumbnail_home_page: {
      suffix: 'alpha_web_thumbnail_home_page_{channelname}_306x172.webp',
      mobile: true,
    },
    thumbnail_channel_page: {
      suffix: 'alpha_web_thumbnail_channel_page_{channelname}_306x172.webp',
      mobile: true,
    },
    thumbnail_channel_page_view_all: {
      suffix:
        'alpha_web_thumbnail_channel_page_view_all_{channelname}_306x172.webp',
      mobile: true,
    },
    thumbnail_category_page: {
      suffix: 'alpha_web_thumbnail_category_page_{channelname}_306x172.webp',
      mobile: true,
    },
    thumbnail_event_page: {
      suffix: 'alpha_web_thumbnail_event_page_{channelname}_268x151.webp',
      mobile: true,
    },
    thumbnail_event_manager: {
      suffix: 'alpha_web_thumbnail_event_manager_{channelname}_98x55.webp',
      mobile: true,
    },
    thumbnail_search_bar: {
      suffix: 'alpha_web_thumbnail_search_bar_{channelname}_90x51.webp',
      mobile: true,
    },
    thumbnail_home_page_carousel: {
      suffix: 'alpha_web_thumbnail_home_page_{channelname}_306x172.webp',
      mobile: true,
    },
    thumbnail_home_page_view_all: {
      suffix:
        'alpha_mobile_thumbnail_home_page_view_all_{channelname}_395x222.webp',
      mobile: true,
    },
    thumbnail_channel: {
      suffix: 'alpha_mobile_thumbnail_channel_{channelname}_196x110.webp',
      mobile: true,
    },
    thumbnail_channel_page_view_all_mobile: {
      suffix:
        'alpha_mobile_thumbnail_channel_page_view_all_{channelname}_395x222.webp',
      mobile: true,
    },
    thumbnail_event_page_streams_list: {
      suffix:
        'alpha_mobile_thumbnail_event_page_streams_list_{channelname}_191x107.webp',
      mobile: true,
    },
    thumbnail_category_page_mobile: {
      suffix: 'alpha_mobile_thumbnail_category_page_{channelname}_395x222.webp',
      mobile: true,
    },
    thumbnail_event_manager_mobile: {
      suffix: 'alpha_mobile_thumbnail_event_manager_{channelname}_98x55.webp',
      mobile: true,
    },
    thumbnail_search_bar_mobile: {
      suffix: 'alpha_mobile_thumbnail_search_bar_{channelname}_90x51.webp',
      mobile: true,
    },
  },
  category: {
    // Define suffixes for category if needed
    homepage_carousel: {
      suffix: 'category_homepage_carousel_{channelname}_36x36.webp',
      mobile: false,
    },
    // Add more mappings as needed
  },
  banners: {
    // Define suffixes for category if needed
    banner_profile_settings_page: {
      suffix:
        'alpha_web_banner_profile_settings_page_{channelname}_650x163.webp',
      mobile: false,
    },
    banner_channel_page: {
      suffix: 'alpha_web_banner_channel_page_{channelname}_1675x419.webp',
      mobile: false,
    },
    banner_profile_settings_page_mobile: {
      suffix:
        'alpha_mobile_banner_profile_settings_page_{channelname}_397x198.webp',
      mobile: true,
    },
    banner_channel_page_mobile: {
      suffix: 'alpha_mobile_banner_channel_page_{channelname}_425x213.webp',
      mobile: true,
    },
    // Add more mappings as needed
  },
  embeded: {
    // Define suffixes for eventThumbnail if needed
    avatar_streams_tab: {
      suffix: 'alpha_web_avatar_streams_tab_{channelname}_40x40.webp',
      mobile: false,
    },
    avatar_side_menu: {
      suffix: 'alpha_web_avatar_side_menu_{channelname}_26x26.webp',
      mobile: false,
    },
    avatar_add_stream: {
      suffix: 'alpha_web_avatar_add_stream_{channelname}_300x300.webp',
      mobile: false,
    },
    avatar_stream_list: {
      suffix: 'alpha_web_avatar_stream_list_{channelname}_122x122.webp',
      mobile: false,
    },
    avatar_streams_tab_mobile: {
      suffix: 'alpha_web_avatar_streams_tab_{channelname}_40x40.webp',
      mobile: true,
    },
    avatar_side_menu_mobile: {
      suffix: 'alpha_web_avatar_side_menu_{channelname}_26x26.webp',
      mobile: true,
    },
    avatar_add_stream_mobile: {
      suffix: 'alpha_web_avatar_add_stream_{channelname}_300x300.webp',
      mobile: true,
    },
    avatar_stream_list_mobile: {
      suffix: 'alpha_web_avatar_stream_list_{channelname}_122x122.webp',
      mobile: true,
    },
  },
};
const useAvatarUrl = (
  thumbnail: 'avatar' | 'eventThumbnail' | 'category' | 'externalAvatar', // Dynamic base type
  type: AvatarType, // Type of avatar
  key: string, // Original Filename
  channel?: string // Optional channel name
): { modifiedUrl: string } => {
  // Define a mapping of types to suffixes and mobile flags

  const domain = process.env.NEXT_PUBLIC_ASSET_CDN;
  if (env === 'production') {
    // return { modifiedUrl: `${domain}${key}` };
  }
  // Use useMemo to optimize performance
  return useMemo(() => {
    const { suffix } = suffixMap[thumbnail][type] || { suffix: '' };
    const modifiedUrl = `${domain}${suffix.replaceAll(
      '{channelname}',
      channel || 'default_channel'
    )}`;
    return { modifiedUrl };
  }, [thumbnail, type, channel]);
};

export default useAvatarUrl;

export const getAvatarUrl = (
  thumbnail: 'avatar' | 'eventThumbnail' | 'category' | 'externalAvatar',
  type: AvatarType,
  key: string,
  channel?: string
): string => {
  const domain = process.env.NEXT_PUBLIC_ASSET_CDN;

  if (env === 'production') {
    // return `${domain}${key}`;
  }
  if (!key) {
    return '';
  }

  const { suffix } = suffixMap[thumbnail][type] || { suffix: '' };
  const modifiedUrl = `${domain}${suffix.replaceAll(
    '{channelname}',
    channel || 'default_channel'
  )}`;
  return modifiedUrl;
};

export const getKey = (
  thumbnail: 'avatar' | 'eventThumbnail' | 'category',
  type: AvatarType,
  channel?: string
) => {
  const { suffix } = suffixMap[thumbnail][type] || { suffix: '' };
  return suffix.replaceAll('{channelname}', channel || 'default_channel');
};

export const useBannerUrl = (
  type: BannerType, // Type of avatar
  key: string, // Original Filename
  channel?: string // Optional channel name
): { modifiedUrl: string } => {
  // Define a mapping of types to suffixes and mobile flags

  const domain = process.env.NEXT_PUBLIC_ASSET_CDN;
  if (env === 'production') {
    // return { modifiedUrl: `${domain}${key}` };
  }
  // Use useMemo to optimize performance
  return useMemo(() => {
    const { suffix } = suffixMap['banners'][type] || { suffix: '' };
    const modifiedUrl = `${domain}users/${channel}/profile/banners/${suffix.replaceAll(
      '{channelname}',
      channel || 'default_channel'
    )}`;
    return { modifiedUrl };
  }, [type, channel]);
};
export const getBannerUrl = (
  type: BannerType, // Type of avatar
  key: string, // Original Filename
  channel?: string // Optional channel name
): string => {
  const domain = process.env.NEXT_PUBLIC_ASSET_CDN;
  const env = process.env.NODE_ENV;

  if (env === 'production') {
    // return `${domain}${key}`;
  }

  const { suffix } = suffixMap['banners'][type] || { suffix: '' };
  const modifiedUrl = `${domain}users/${channel}/profile/banners/${suffix.replaceAll(
    '{channelname}',
    channel || 'default_channel'
  )}`;

  return modifiedUrl;
};

function getFolderInfo(filePath) {
  const parts = filePath.split('/').filter(Boolean); // Split by "/" and remove empty parts

  return {
    folderPath: parts.slice(0, -1).join('/'), // Exclude filename
    lastFolderName: parts[parts.length - 2] || null, // Second last element (last folder)
    filename: parts[parts.length - 1] || null, // Last element (filename)
  };
}

export const useThumbnailUrl = (
  thumbnail: 'avatar' | 'eventThumbnail' | 'category', // Dynamic base type
  type: ThumbnailType, // Type of avatar
  key: string, // Original Filename
  slug?: string, // Optional event slug
  channel?: string // Optional channel name
): { modifiedUrl: string } => {
  // Define a mapping of types to suffixes and mobile flags
  const domain = process.env.NEXT_PUBLIC_ASSET_CDN;
  if (env === 'production') {
    // return { modifiedUrl: `${domain}${key}` };
  }
  if (slug === null) {
    return { modifiedUrl: '' };
  }
  const { folderPath: directory, lastFolderName: slugV } = getFolderInfo(slug);
  // Use useMemo to optimize performance
  return useMemo(() => {
    const { suffix } = suffixMap[thumbnail][type] || { suffix: '' };
    const modifiedUrl = `${domain}${directory}/${suffix
      .replaceAll('{channelname}', channel || 'default_channel')
      .replace('{slug}', slugV)}`;
    return { modifiedUrl };
  }, [thumbnail, type, channel]);
};

export const getThumbnailKey = (
  thumbnail: 'avatar' | 'eventThumbnail' | 'category',
  type: ThumbnailType,
  key: string,
  channel?: string
): { modifiedUrl: string } => {
  const domain = process.env.NEXT_PUBLIC_ASSET_CDN;
  if (process.env.NODE_ENV === 'production') {
    // return { modifiedUrl: `${domain}${key}` };
  }

  if (!key) {
    return { modifiedUrl: '' };
  }

  const { folderPath: directory, lastFolderName: slugV } = getFolderInfo(key);
  const { suffix = '' } = suffixMap[thumbnail]?.[type] || {};

  const modifiedUrl = `${domain}${directory}/${suffix
    .replaceAll('{channelname}', channel || 'default_channel')
    .replace('{slug}', slugV)}`;

  return { modifiedUrl };
};
export const usePanelUrl = (
  thumbnail: 'event_panel' | 'channel_panel', // Dynamic base type
  key: string, // Original Filename
  channel?: string // Optional channel name
): { modifiedUrl: string } => {
  // Define a mapping of types to suffixes and mobile flags
  const domain = process.env.NEXT_PUBLIC_ASSET_CDN;
  if (env === 'production') {
    // return { modifiedUrl: `${domain}${key}` };
  }
  if (!key) {
    return { modifiedUrl: '' };
  }
  const { folderPath: directory, filename } = getFolderInfo(key);
  if (!filename) {
    return { modifiedUrl: '' };
  }
  // Use useMemo to optimize performance
  if (filename.includes('.gif')) {
    const modifiedUrl = `${domain}${key}`;
    return { modifiedUrl };
  }
  return useMemo(() => {
    const modifiedUrl = `${domain}${directory}/${filename}`;
    return { modifiedUrl };
  }, [domain, directory, filename]);
};

export const getStreamEmbedUrl = (
  thumbnail: 'embeded' | 'klic' | 'enterprise',
  type: StreamEmbedType,
  key: string,
  streamName?: string
): string => {
  const domain = process.env.NEXT_PUBLIC_ASSET_CDN;
  if (startsWithHttps(key)) {
    return key;
  }
  if (process.env.NODE_ENV === 'production') {
    // return `${domain}${key}`;
  }
  if (!key) {
    return '';
  }
  const { folderPath: directory, lastFolderName: slugV } = getFolderInfo(key);
  const { suffix = '' } = suffixMap[thumbnail]?.[type] || {};
  const modifiedUrl = `${domain}${directory}/${suffix.replaceAll(
    '{channelname}',
    streamName || 'default_channel'
  )}`;

  return modifiedUrl;
};
